document.addEventListener('DOMContentLoaded', function () {
    const titles = document.querySelectorAll('.mm-faq__inner__questions--title');
    titles.forEach(function (title) {
      title.addEventListener('click', function () {
        const li = title.closest('li');
        const answer = li.querySelector('.mm-faq__inner__questions--answer');
        const btn = li.querySelector('.mm-faq__toggle');
        const isOpen = answer.style.display === 'block';
  
        document.querySelectorAll('.mm-faq__inner__questions--answer').forEach(a => a.style.display = 'none');
        document.querySelectorAll('.mm-faq__toggle').forEach(b => {
          b.textContent = '+';
          b.setAttribute('aria-expanded', 'false');
        });
  
        if (!isOpen) {
          answer.style.display = 'block';
          btn.textContent = '–';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });